import { useNavigate } from "react-router-dom";
import { markOnboardingSkipped } from "../state";
import { Tape } from "./Bits";

/** The two steps, always in view and always tappable: the piece you love, then the one you're eyeing.
 *  The tape under them has an inch per question and fills as they're answered. */
export function Steps(props: { at: 1 | 2; favDone: boolean; eyeingDone: boolean; answered: number; questions: number }) {
  const { at, favDone, eyeingDone, answered, questions } = props;
  const nav = useNavigate();
  const n = questions + 1;
  return (
    <div className="stepsbar">
      <ol className="steps" aria-label="Steps">
        <li>
          <button type="button" className={at === 1 ? "on" : favDone ? "done" : ""} aria-current={at === 1 ? "step" : undefined} onClick={() => at !== 1 && nav("/favorite")}>
            <b>1</b>Your favorite
          </button>
        </li>
        <li>
          <button
            type="button"
            className={at === 2 ? "on" : eyeingDone ? "done" : ""}
            aria-current={at === 2 ? "step" : undefined}
            onClick={() => {
              if (at === 2) return;
              markOnboardingSkipped(); // they chose to go straight to the link; don't send them back to step 1
              nav("/");
            }}
          >
            <b>2</b>What you're eyeing
          </button>
        </li>
      </ol>
      <Tape n={n} fill={(Math.min(n, answered) / n) * 100} />
    </div>
  );
}
